<template>
  <div class="container">
    <HeaderView />
    <div
      :class="{
      'bg-content': $store.state.screenWidth > 375,
      'bg-content-se':
        $store.state.screenWidth <= 375 && $store.state.screenWidth > 320,
      'bg-content-4': $store.state.screenWidth <= 320,
    }"
      style="overflow: hidden !important;"
    >
      <div
        class="activity-page"
        style="color: #555555;"
      >
        <div class="row mb-3">
          <div
            class="col-10 d-flex justify-content-start align-items-center"
            style="
              font-weight: 400;
              color: #555555;
              font-family: 'Mitr', sans-serif;
            "
            :style="{
              'font-size': $store.state.screenWidth <= 320 ? '18px' : '22px',
            }"
          >
            <i class="ti ti-chalkboard"></i>
            &nbsp;กิจกรรมที่ได้เข้าร่วม
          </div>
          <div class="col-2 d-flex justify-content-end align-items-center">
            <router-link
              to="/workshop"
              class="activity-empty-action activity-nav-action"
            >
              <i class="ti ti-search"></i>
              <span>กิจกรรม</span>
            </router-link>
          </div>
        </div>
      </div>
      <div
        class="activity-page activity-list pb-0"
        style="height: 70vh; overflow-y: auto; overflow-x: hidden;"
      >
        <div class="row">
          <div
            class="col-12 text-center pt-5"
            v-if="isLoad === true && ws_list.length < 1"
          >
            <div
              class="spinner-border text-azure"
              role="status"
            ></div>
          </div>
          <div
            class="col-12"
            v-if="isLoad === false && ws_list.length < 1"
          >
            <div class="activity-empty">
              <div
                class="activity-empty-icon"
                aria-hidden="true"
              >
                <i class="ti ti-calendar-search"></i>
              </div>
              <div class="activity-empty-copy">
                <span class="activity-empty-label">กิจกรรมของฉัน</span>
                <h3>ยังไม่มีกิจกรรมที่เข้าร่วม</h3>
                <p>เลือกกิจกรรมที่สนใจ แล้วสแกน QR Code เพื่อบันทึกการเข้าร่วม</p>
              </div>
            </div>
          </div>
          <div
            class="col-sm-4 p-2"
            v-for="(ws, i) in ws_list"
            :key="i"
          >
            <div
              class="activity-card"
              :style="{ background: LightenDarkenColor(ws.facColor, 40) }"
            >
              <img
                :src="'/static/img/logo/' + ws.facId + '.png'"
                class="activity-card-logo"
                :alt="'logo_' + ws.facId + '.png'"
              />
              <span
                class="badge"
                :style="{ background: ws.facColor }"
              >
                {{ ws.facName }}
              </span>
              <div class="mt-2 activity-title">{{ ws.workshopName }}</div>
              <a
                :href="$store.state.URL + 'cert/' + ws.workshopRegisterCode"
                class="badge activity-cert"
                target="_blank"
                :style="{ background: ws.facColor }"
              >
                <i class="ti ti-printer"></i>
                &nbsp;พิมพ์ใบประกาศ
              </a>
            </div>
          </div>
          <hr
            class="mt-2"
            style="margin-bottom: 20px;"
          />
          <a
            href="https://forms.cloud.microsoft/r/j56zC3gRM4"
            target="_blank"
            class="assessment-panel"
            v-if="assessment_is_open == 1"
            @click="clickAssessment()"
          >
            <div
              class="assessment-icon"
              aria-hidden="true"
            >
              <i class="ti ti-clipboard-check"></i>
            </div>
            <div class="assessment-copy">
              <span>แบบประเมินหลังเข้าร่วมงาน</span>
              <h3>แบบสอบถามความพึงพอใจ</h3>
              <p>กรุณาตอบแบบสอบถามเพื่อรับใบประกาศเข้าร่วมงาน</p>
            </div>
            <button
              type="button"
              class="assessment-action"
            >
              <span>ทำแบบสอบถาม</span>
              <i class="ti ti-arrow-right"></i>
            </button>
          </a>
          <div style="width: 100%; height: 200px;" />
        </div>
      </div>
    </div>
    <FooterbarView />

    <!-- Modal -->
    <div
      class="modal fade"
      id="ScanModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="ScanModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog scan-dialog modal-dialog-centered modal-fullscreen-sm-down">
        <div class="modal-content scan-modal-content">
          <div class="scan-header">
            <div>
              <span>QR Check-in</span>
              <h3>สแกนเข้าร่วมกิจกรรม</h3>
            </div>
            <button
              type="button"
              class="scan-close"
              id="mdClose"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
          <div class="modal-body scan-body">
            <div class="scan-stage">
              <div
                class="scan-loading"
                v-if="paused === true"
              >
                <div
                  class="spinner-border"
                  role="status"
                />
                <span>กำลังเปิดกล้อง</span>
              </div>
              <qrcode-stream
                :camera="camera"
                @decode="onDecode"
                @init="onInit"
                @locate="onLocate"
                :paused="paused"
                class="scan-camera"
                v-show="support === true && paused === false"
                :torch="torchActive"
              >
                <div class="qrm_container">
                  <div class="qrm_top_bottom" />
                  <div class="qrm_middle">
                    <div class="qrm_middle_l" />
                    <div class="qrm_middle_m" />
                    <div class="qrm_middle_r" />
                  </div>
                  <div class="qrm_top_bottom" />
                </div>
              </qrcode-stream>
            </div>
            <div class="scan-hint">
              <i class="ti ti-scan"></i>
              <span>วาง QR Code ให้อยู่ในกรอบเพื่อเข้าร่วมกิจกรรม</span>
            </div>
            <div
              class="button-wrapper"
              v-if="support == false"
            >
              <span class="label">Press for Scan QR Code</span>
              <qrcode-capture
                @detect="onDetect"
                id="upload"
                class="upload-box"
              />
            </div>
            <div class="row justify-content-center">
              <div class="col-md-12 d-grid gap-2">
                <button
                  @click="torchActive = !torchActive"
                  v-if="!torchNotSupported"
                  class="btn scan-torch"
                >
                  <span v-if="!torchActive">
                    <i class="ti ti-bulb"></i>
                    เปิดไฟฉาย
                  </span>
                  <span v-if="torchActive">
                    <i
                      class="ti ti-bulb-off"
                      v-if="torchActive"
                    ></i>
                    ปิดไฟฉาย
                  </span>
                </button>
              </div>
            </div>
            <div
              class="text-center w-100"
              v-if="error != '' && error_show == true"
            >
              <span class="error">{{ error }}</span>
            </div>
          </div>
          <div class="scan-footer">
            <button
              type="button"
              class="btn scan-close-bottom"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              ปิดการสแกน
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'
import HeaderView from './layouts/HeaderView.vue'
import FooterbarView from './layouts/FooterbarView.vue'
import Swal from 'sweetalert2'
import moment from 'moment'
import api from '../assets/services'
import $ from 'jquery'

export default {
  components: {
    HeaderView,
    FooterbarView,
    QrcodeStream,
    QrcodeCapture,
  },
  data () {
    return {
      ws_list: [],
      isLoad: true,
      result: '',
      error: '',
      paused: true,
      support: true,
      error_show: false,
      camera: 'off',
      torchActive: false,
      torchNotSupported: false,
      scanModalEl: null,
      openCameraTimer: null,
      assessment_is_open: 0
    }
  },
  methods: {
    startScanner () {
      this.stopScanner()
      this.openCameraTimer = setTimeout(() => {
        this.camera = 'auto'
        this.paused = false
        this.openCameraTimer = null
      }, 1000)
    },
    stopScanner () {
      if (this.openCameraTimer) {
        clearTimeout(this.openCameraTimer)
        this.openCameraTimer = null
      }

      this.camera = 'off'
      this.paused = true
      this.torchActive = false
    },
    handleScanModalHide (event) {
      if (event.target.id === 'ScanModal') {
        this.stopScanner()
      }
    },
    handleScanModalShow (event) {
      if (event.target.id === 'ScanModal') {
        this.startScanner()
      }
    },
    LightenDarkenColor (col, amt) {
      var usePound = false
      if (col[0] === '#') {
        col = col.slice(1)
        usePound = true
      }
      var num = parseInt(col, 16)
      var r = (num >> 16) + amt
      if (r > 255) r = 255
      else if (r < 0) r = 0
      var b = ((num >> 8) & 0x00ff) + amt
      if (b > 255) b = 255
      else if (b < 0) b = 0
      var g = (num & 0x0000ff) + amt
      if (g > 255) g = 255
      else if (g < 0) g = 0
      return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
    },
    onDecode (result) {
      this.stopScanner()
      this.CheckData(result)
      $('#mdClose').click()
    },
    async onDetect (promise) {
      try {
        const { content } = await promise
        if (content === null) {
          Swal.fire({
            title:
              '<strong style="font-family: \'Mitr\', sans-serif">สแกน QRCode</strong>',
            type: 'warning',
            html:
              '<span style="font-family: \'Mitr\', sans-serif; color: red;">ไม่พบกล้อง</span>',
          })
        } else {
          this.CheckData(content)
          this.stopScanner()
          // eslint-disable-next-line no-undef
          $('#mdClose').click()
        }
      } catch (_error) {
        Swal.fire({
          title:
            '<strong style="font-family: \'Mitr\', sans-serif">สแกน QRCode</strong>',
          type: 'warning',
          html:
            '<span style="font-family: \'Mitr\', sans-serif; color: red;">ไม่พบกล้อง</span>',
        })
      }
    },
    async onInit (promise) {
      try {
        const { capabilities } = await promise
        this.support = true
        this.torchNotSupported = !capabilities.torch
      } catch (error) {
        this.support = true
        if (error.name === 'NotAllowedError') {
          this.support = false
          this.error_show = true
          this.error = 'ERROR: you need to grant camera access permisson'
        } else if (error.name === 'NotFoundError') {
          this.support = false
          this.error_show = false
          this.error = 'ERROR: no camera on this device'
        } else if (error.name === 'NotSupportedError') {
          this.support = false
          this.error_show = true
          this.error = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.support = false
          this.error_show = false
          this.error = 'ERROR: is the camera already in use?'
        } else if (error.name === 'OverconstrainedError') {
          this.support = false
          this.error_show = true
          this.error = 'ERROR: installed cameras are not suitable'
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.support = false
          this.error_show = false
          this.error = 'ERROR: Stream API is not supported in this browser'
        }
      }
    },
    onLocate (points) {
      console.log(points)
    },
    async CheckData (code) {
      this.$store.state.isLoading = true
      api.addMyWorkShop(
        this.$store.state.URL,
        {
          workshop_code: code,
        },
        this.header,
        async (result) => {
          if (result.status === 'SUCCESS') {
            Swal.fire({
              title:
                '<strong style="font-family: \'Mitr\', sans-serif">เข้าร่วมกิจกรรม</strong>',
              icon: 'success',
              html:
                '<span style="font-family: \'Mitr\', sans-serif;">' +
                result.message +
                ' </span>',
            })
            await this.myWorkshop()
            this.$store.state.isLoading = false
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'เข้าร่วมกิจกรรม',
              text: 'ไม่สามารถเข้าร่วมกิจกรรม เนื่องจาก' + result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ตกลง',
            }).then(async (result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                await this.checkUser()
                await this.myWorkshop()
              }
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    async myWorkshop () {
      this.isLoad = true
      this.ws_list = []
      api.getMyWorkShop(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.ws_list = result.data
            this.isLoad = false
          } else {
            this.isLoad = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          localStorage.clear()
          this.$router.push('/').catch(() => { })
          this.$store.state.isLoading = false
        },
      )
    },
    async clickAssessment () {
      api.addAssessment(
        this.$store.state.URL,
        {},
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.myWorkshop()
            this.isLoad = false
          } else {
            if (result.message === 'กิจกรรมนี้ได้ลงทะเบียนแล้ว') {
              // window.open('https://forms.cloud.microsoft/r/j56zC3gRM4', '_blank')
            } else {
              Swal.fire({
                // title: result.message,
                text: result.message,
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'ตกลง',
                denyButtonText: 'ยกเลิก',
              }).then((result) => {
                this.isLoad = false
              })
            }
          }
        },
        (_error) => {
          localStorage.clear()
          this.$router.push('/').catch(() => { })
          this.$store.state.isLoading = false
        },
      )
    },
    getConfig () {
      api.getConfig(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            result.data.forEach((v) => {
              if (v === moment().format('YYYY-MM-DD')) {
                this.assessment_is_open = 1
              }
            })
          } else {
            this.$store.state.isLoading = false
            localStorage.clear()
            this.$router.push('/').catch(() => { })
          }
        },
        (_error) => {
          localStorage.clear()
          this.$router.push('/').catch(() => { })
          this.$store.state.isLoading = false
        },
      )
    },
  },
  async mounted () {
    this.scanModalEl = document.getElementById('ScanModal')
    if (this.scanModalEl) {
      this.scanModalEl.addEventListener('hide.bs.modal', this.handleScanModalHide)
      this.scanModalEl.addEventListener('hidden.bs.modal', this.handleScanModalHide)
      this.scanModalEl.addEventListener('show.bs.modal', this.handleScanModalShow)
    }
    setTimeout(async () => {
      const auth = this.callbackToken(this.$store.state.user.citizenId)
      if (auth) {
        await this.getProfile()
        await this.getConfig()
        await this.myWorkshop()
      } else {
        localStorage.clear()
        this.$router.push('/').catch(() => { })
      }
    }, 500)
  },
  beforeDestroy () {
    this.stopScanner()
    if (this.scanModalEl) {
      this.scanModalEl.removeEventListener('hide.bs.modal', this.handleScanModalHide)
      this.scanModalEl.removeEventListener('hidden.bs.modal', this.handleScanModalHide)
      this.scanModalEl.removeEventListener('show.bs.modal', this.handleScanModalShow)
    }
  },
  beforeRouteLeave (to, from, next) {
    this.stopScanner()
    next()
  },
}
</script>

<style scoped>
.activity-page {
  width: min(1180px, calc(100% - 20px));
  margin: 0 auto;
  padding: 22px 0 0;
}

.activity-list {
  padding-top: 0;
}

.activity-empty {
  width: min(680px, calc(100% - 24px));
  min-height: 260px;
  margin: 40px auto 24px;
  padding: 34px 28px;
  border: 1px solid rgba(185, 130, 46, 0.22);
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  color: #3d3025;
  background: radial-gradient(circle at 88% 14%, rgba(185, 130, 46, 0.13), transparent 27%), linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(255, 249, 239, 0.94));
  box-shadow: 0 18px 44px rgba(76, 50, 31, 0.1);
  text-align: center;
  font-family: 'Mitr', sans-serif;
}

.activity-empty::after {
  content: '';
  width: 150px;
  height: 150px;
  position: absolute;
  right: -65px;
  bottom: -80px;
  border: 22px solid rgba(185, 130, 46, 0.07);
  border-radius: 50%;
}

.activity-empty-icon {
  width: 78px;
  height: 78px;
  margin-bottom: 18px;
  border: 1px solid rgba(185, 130, 46, 0.28);
  border-radius: 24px;
  display: grid;
  place-items: center;
  color: #8b591e;
  background: linear-gradient(135deg, #fff3d9, #f3d093);
  box-shadow: 0 10px 24px rgba(185, 130, 46, 0.18);
  font-size: 38px;
}

.activity-empty-copy {
  position: relative;
  z-index: 1;
}

.activity-empty-label {
  color: #a17138;
  font-size: 12px;
  letter-spacing: 0.05em;
}

.activity-empty h3 {
  margin: 4px 0 8px;
  color: #2f241b;
  font-size: 23px;
  font-weight: 600;
}

.activity-empty p {
  margin: 0;
  color: #806f60;
  font-size: 14px;
  line-height: 1.65;
}

.activity-empty-action {
  min-height: 44px;
  margin-top: 22px;
  padding: 0 20px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
  z-index: 1;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  box-shadow: 0 9px 20px rgba(90, 59, 37, 0.18);
  text-decoration: none;
  font-size: 14px;
}

.activity-empty-action:hover {
  color: #ffffff;
  transform: translateY(-1px);
}

.activity-nav-action {
  min-height: 40px;
  margin-top: 0;
  padding: 0 16px;
  white-space: nowrap;
}

.assessment-panel {
  width: calc(100% - 16px);
  min-height: 112px;
  margin: 18px auto 8px;
  padding: 18px 20px;
  border: 1px solid rgba(185, 130, 46, 0.24);
  border-radius: 14px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  color: #3d3025;
  background: linear-gradient(120deg, rgba(255, 253, 248, 0.98), rgba(255, 241, 215, 0.94));
  box-shadow: 0 10px 28px rgba(76, 50, 31, 0.08);
  font-family: 'Mitr', sans-serif;
  text-align: left;
}

.assessment-icon {
  width: 58px;
  height: 58px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  color: #81531f;
  background: linear-gradient(135deg, #ffe8bd, #e9bd70);
  font-size: 29px;
}

.assessment-copy span {
  color: #a17138;
  font-size: 11px;
}

.assessment-copy h3 {
  margin: 2px 0 3px;
  color: #2f241b;
  font-size: 18px;
  font-weight: 600;
}

.assessment-copy p {
  margin: 0;
  color: #806f60;
  font-size: 12px;
}

.assessment-action {
  min-height: 44px;
  padding: 0 18px;
  border: 0;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  box-shadow: 0 9px 20px rgba(90, 59, 37, 0.18);
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.assessment-action:hover {
  transform: translateY(-1px);
}

.activity-card {
  width: 100%;
  height: 194px;
  padding: 10px;
  border-radius: 12px 45px;
  position: relative;
  overflow: hidden;
}

.activity-card-logo {
  position: absolute;
  top: -10px;
  right: -15%;
  height: 180px;
  width: auto;
  opacity: 0.2 !important;
}

.activity-title {
  color: #ffffff;
  font-size: 22px;
  display: -webkit-box;
  height: 170px !important;
  width: 90%;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  max-height: 110px;
  line-height: 35px;
  word-wrap: break-word;
  overflow: hidden;
  white-space: normal;
  font-family: 'Mitr', sans-serif;
}

.activity-cert {
  font-size: 16px;
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.scan-dialog {
  font-family: 'Mitr', sans-serif;
}

.scan-modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 10px;
  background: #1f1710;
  color: #ffffff;
}

.scan-header {
  min-height: 70px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: linear-gradient(135deg, #4c321f, #8a5d24);
}

.scan-header span {
  display: block;
  margin-bottom: 2px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
}

.scan-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
}

.scan-close {
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  display: inline-grid;
  place-items: center;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.12);
  font-size: 24px;
}

.scan-body {
  padding: 0;
  background: #120d09;
}

.scan-stage {
  position: relative;
  width: 100%;
  height: min(68vh, 620px);
  min-height: 420px;
  overflow: hidden;
  display: grid;
  place-items: center;
  background: #120d09;
}

.scan-camera {
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow: hidden;
  background: #120d09;
}

.scan-loading {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 14px;
  color: #f5e4c9;
  background: #120d09;
}

.scan-loading .spinner-border {
  width: 42px;
  height: 42px;
  color: #d7a34a;
}

.scan-hint {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #f5e4c9;
  background: #1f1710;
  font-size: 14px;
  line-height: 1.45;
}

.scan-hint i {
  color: #d7a34a;
  font-size: 22px;
}

.scan-torch {
  min-height: 44px;
  margin: 12px 16px 0;
  border: 1px solid rgba(215, 163, 74, 0.34);
  color: #f5e4c9;
  background: rgba(215, 163, 74, 0.12);
  font-family: 'Mitr', sans-serif;
}

.scan-torch span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.scan-torch i {
  font-size: 20px;
}

.scan-footer {
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: #1f1710;
}

.scan-close-bottom {
  width: 100%;
  min-height: 48px;
  border: 0;
  border-radius: 8px;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  font-family: 'Mitr', sans-serif;
  font-size: 17px;
}

.button-wrapper {
  padding: 16px;
  color: #f5e4c9;
}

.error {
  display: block;
  padding: 10px 16px;
  color: #ffb4a8;
  font-family: 'Mitr', sans-serif;
}

.qrm_container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.qrm_top_bottom {
  width: 100%;
  flex: 1;
  background-color: rgba(1, 1, 1, 0.54);
}

.qrm_middle {
  display: flex;
  flex-direction: row;
  height: min(68vw, 300px);
}

.qrm_middle_l {
  flex: 1;
  background-color: rgba(1, 1, 1, 0.54);
}

.qrm_middle_m {
  width: min(68vw, 300px);
  background-color: transparent;
  background: linear-gradient(to right, #d7a34a 4px, transparent 4px) 0 0, linear-gradient(to right, #d7a34a 4px, transparent 4px) 0 100%, linear-gradient(to left, #d7a34a 4px, transparent 4px) 100% 0,
    linear-gradient(to left, #d7a34a 4px, transparent 4px) 100% 100%, linear-gradient(to bottom, #d7a34a 4px, transparent 4px) 0 0, linear-gradient(to bottom, #d7a34a 4px, transparent 4px) 100% 0,
    linear-gradient(to top, #d7a34a 4px, transparent 4px) 0 100%, linear-gradient(to top, #d7a34a 4px, transparent 4px) 100% 100%;
  background-repeat: no-repeat;
  background-size: 34px 34px;
}

.qrm_middle_r {
  flex: 1;
  background-color: rgba(1, 1, 1, 0.54);
}

@media (max-width: 575px) {
  .activity-page {
    width: calc(100% - 14px);
    padding-top: 14px;
  }

  .activity-list {
    padding-top: 0;
  }

  .activity-empty {
    width: 100%;
    min-height: 240px;
    margin-top: 24px;
    padding: 28px 18px;
    border-radius: 14px;
  }

  .activity-empty-icon {
    width: 68px;
    height: 68px;
    border-radius: 20px;
    font-size: 33px;
  }

  .activity-empty h3 {
    font-size: 20px;
  }

  .activity-empty p {
    font-size: 13px;
  }

  .activity-nav-action {
    min-height: 36px;
    padding: 0 12px;
    font-size: 12px;
  }

  .assessment-panel {
    width: 100%;
    padding: 18px;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 12px;
  }

  .assessment-icon {
    width: 50px;
    height: 50px;
    border-radius: 14px;
    font-size: 25px;
  }

  .assessment-copy h3 {
    font-size: 16px;
  }

  .assessment-action {
    width: 100%;
    grid-column: 1 / -1;
  }

  .scan-modal-content {
    min-height: 100vh;
    border-radius: 0;
  }

  .scan-header {
    min-height: 64px;
    padding: 12px 14px;
  }

  .scan-stage {
    height: calc(100vh - 64px - 54px - 76px);
    min-height: 320px;
  }

  .scan-hint {
    min-height: 54px;
    padding: 8px 14px;
    font-size: 13px;
  }

  .qrm_middle {
    height: min(72vw, 280px);
  }

  .qrm_middle_m {
    width: min(72vw, 280px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Activity.vue